import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./timeline.scss";

const TimelineEvent = ({ icon, contentSize = "default", className, children, ...props }) => {
  const classes = classnames(
    "timeline-event",
    {
      "timeline-event--large": contentSize === "large",
    },
    className
  );
  return (
    <div className={classes} {...props}>
      {icon({ className: "timeline-event__icon" })}
      <div className="timeline-event__content">{children}</div>
    </div>
  );
};

TimelineEvent.propTypes = {
  /**
   * Icon to be rendered on the left hand side of the component
   */
  icon: PropTypes.func.isRequired,
  /**
   * Size of the heading ('default' or 'large')
   */
  contentSize: PropTypes.oneOf(["default", "large"]),
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.objectOf(PropTypes.node),
  ]).isRequired,
};

TimelineEvent.defaultProps = {
  contentSize: "default",
  className: "",
};

export default TimelineEvent;
